function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/no-unused-prop-types */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Checkbox, Toggle } from './elements';
/**
 * A Toggle Button represents the switch between two states, on or off.
 *
 * @return {jsx}
 */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/interactive-supports-focus */

/* eslint-disable jsx-a11y/no-static-element-interactions */

var ToggleButton = /*#__PURE__*/function (_PureComponent) {
  _inherits(ToggleButton, _PureComponent);

  var _super = _createSuper(ToggleButton);

  function ToggleButton() {
    var _this;

    _classCallCheck(this, ToggleButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isChecked: _this.props.isDefaultChecked // eslint-disable-line react/destructuring-assignment

    });

    _defineProperty(_assertThisInitialized(_this), "isControlled", function (prop) {
      var props = _this.props;
      return props.hasOwnProperty(prop);
    });

    _defineProperty(_assertThisInitialized(_this), "getControllableValue", function (key) {
      var props = _this.props;
      var state = _this.state;
      return _this.isControlled(key) ? props[key] : state[key];
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggle", function () {
      var _this$props = _this.props,
          isDisabled = _this$props.isDisabled,
          onToggle = _this$props.onToggle;

      var isChecked = _this.getControllableValue('isChecked');

      if (isDisabled) return;

      if (_this.isControlled('isChecked')) {
        onToggle && onToggle(!isChecked);
      } else {
        _this.setState({
          isChecked: !isChecked
        }, function () {
          onToggle && onToggle(!isChecked);
        });
      }
    });

    return _this;
  }

  _createClass(ToggleButton, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          isDisabled = _this$props2.isDisabled;
      var isChecked = this.getControllableValue('isChecked');
      return /*#__PURE__*/React.createElement("div", {
        className: className,
        onClick: this.handleToggle
      }, /*#__PURE__*/React.createElement(Checkbox, {
        type: "checkbox",
        isChecked: isChecked,
        readOnly: true
      }), /*#__PURE__*/React.createElement(Toggle, {
        isChecked: isChecked,
        readOnly: isDisabled,
        "data-testid": "toggle-button"
      }));
    }
  }]);

  return ToggleButton;
}(PureComponent);
/** Prop types. */


_defineProperty(ToggleButton, "displayName", 'ToggleButton');

ToggleButton.propTypes = {
  /** className needed by styled-components */
  className: PropTypes.string,

  /** Whether the button is checked or not in controlled component */
  // eslint-disable-next-line react/require-default-props
  isChecked: PropTypes.bool,

  /** Whether the button is checked or not in uncontrolled component */
  isDefaultChecked: PropTypes.bool,

  /** Whether the button is disabled or not */
  isDisabled: PropTypes.bool,

  /** Callback when component is clicked */
  onToggle: PropTypes.func
};
/** Default props. */

ToggleButton.defaultProps = {
  className: '',
  isDefaultChecked: false,
  isDisabled: false,
  onToggle: null
};
export default styled(ToggleButton).withConfig({
  displayName: "ToggleButton",
  componentId: "l335sv-0"
})(["cursor:", ";display:inline-block;height:2rem;position:relative;vertical-align:middle;"], function (_ref) {
  var isDisabled = _ref.isDisabled;
  return isDisabled ? 'not-allowed' : 'pointer';
});